module.exports = __webpack_public_path__ + "static/media/program4.513dfbcd.webp";